
    export * from '@nexxe/bn-customer-info-v2';
    export * from '@nexxe/bn-customer-info-v2/nexxe-bn-customer-info-v2.ngfactory';
    import { BnCustomerInfoV2ModuleNgFactory } from '@nexxe/bn-customer-info-v2/nexxe-bn-customer-info-v2.ngfactory';
    export default BnCustomerInfoV2ModuleNgFactory;
  